// A hand-set 'YYYY-MM-DD' content date as an ISO timestamp (09:00 SGT, same
// convention as PRICES_REVIEWED on the aircon price page). Use it for
// dateModified / article:modified_time instead of getArticleDateTime's
// modifiedDate, which is the build time and so advances on every ISR rebuild
// whether or not the page changed - a freshness signal Google learns to ignore.
export const reviewedIso = (date) => `${date}T09:00:00+08:00`

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// Everything a page needs from its hand-set CONTENT_REVIEWED date: the ISO
// timestamp for dateModified / article:modified_time, and the month/year shown
// in titles and "Updated" labels - so a title says 2026 only when the page
// actually changed in 2026. Same shape as getArticleDateTime(). See "Page
// last-updated date" in CLAUDE.md.
export const contentDate = (date) => {
    const [year, month] = date.split('-').map(Number)
    return { modifiedDate: reviewedIso(date), month: MONTH_NAMES[month - 1], year }
}

// Build time, so it moves on every ISR rebuild. Only for things that really are
// "now" (the footer's copyright year) - never a page's modified date.
export const getArticleDateTime = () => {
    const toIsoString = (date) => {
        const tzo = -date.getTimezoneOffset(), dif = tzo >= 0 ? '+' : '-', pad = function (num) {
            return (num < 10 ? '0' : '') + num;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    };
    const dt = new Date();
    const modifiedDate = toIsoString(dt);
    const year = dt.getFullYear();
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[dt.getMonth()];
    return { modifiedDate, month, year };
}